<template>
    <div class='bg-box'>
    <span class='head' style='display: flex; flex-direction: column'>
        <img style='width: 80%; display: flex' src='@/assets/images/title.png'>
        <p>我的积分：{{userInfo.integral || 0}} 每次消耗：{{integral}}</p>
        <span v-if="integralDesc" style="padding-top: 7px;color:#fff">说明：{{integralDesc}}</span>
    </span>
        <div class='j-list'>
            <span v-for="(item, index) in list" v-if="index<=3" :class="{cur: currentIndex === index}"><img :src="item.image"></span>
            <span @click="luckyStart" :class="{cur: currentIndex < 0}"><img src="@/assets/images/begin.png"></span>
            <span v-for="(item, index) in list" v-if="index>=4" :class="{cur: currentIndex === index}"><img :src="item.image"></span>
        </div>
        <div class="slider-banner swiper" style="height: 30px">
            <swiper class="swiper-wrapper" :options="RecommendSwiper">
                <swiperSlide
                        class="swiper-slide"
                        v-for="(item, index) in luckyList"
                        :key="index"
                        style="text-align: center"
                >
                    <span style="color:#fff;text-align: center">{{item}}</span>
                </swiperSlide>
            </swiper>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import {getUser, getConfigure, luckyIntegralList, luckyIntegral, luckyMsgList} from "@api/user";

    export default {
        name: "LuckyIntegral",
        components: {
            swiper,
            swiperSlide
        },
        data() {
            return {
                integral: 20,
                userInfo: {integral: 0},
                currentIndex: -1,
                luckyIndex: -1,
                list: [],
                start: 0,
                qTime: 100,
                lTime: 800,
                loopTimes: 0,
                maxTimes: 5,
                noClick: false,
                loopInterval: null,
                slow: false,
                enable: 1,
                loopList : [0, 1, 2, 4, 7, 6, 5, 3],
                integralDesc: '',
                luckyList: [],
                RecommendSwiper: {
                    direction: 'vertical',
                    height: 28,
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 2000
                    },
                    loop: true,
                    speed: 1000,
                    loopedSlides:1,
                    observer: true,
                    observeParents: true
                }
            }
        },
        watch:{
            $route(to,from){
                this.showFlag = false
            }
        },
        mounted() {
            this.getConfig()
            this.getList()
            this.getUserInfo()
            this.getLuckyMsgList()
        },
        methods: {
            // 中奖列表
            getLuckyMsgList() {
                let that = this
                luckyMsgList().then(res => {
                    that.luckyList = res.data;
                });
            },
            // 用户信息
            getUserInfo(){
                let that = this;
                getUser().then(res => {
                    that.userInfo = res.data;
                });
            },
            // 获取积分配置
            getConfig() {
                let that = this;
                getConfigure().then(
                    res => {
                        that.integral = res.data.lucky_integral
                        that.integralDesc = res.data.lucky_integral_desc || ''
                        // that.enable = res.data.lucky_integral_enable
                        // if (that.enable <= 0) {
                        //     that.$dialog.success('积分抽奖暂未开启').then(() => {
                        //         that.$router.push({path: "/"})
                        //     })
                        // }
                    },
                    err => {
                        that.$dialog.message(err.msg);
                    }
                );
            },
            // 获取奖品列表
            getList() {
                let that = this
                luckyIntegralList().then(
                    res => {
                        that.list = res.data
                    },
                    err => {
                        that.$dialog.message(err.msg);
                    }
                );
            },
            // 中奖后的逻辑
            luckyStart() {
                if (this.enable <= 0) {
                    this.$dialog.error('积分抽奖暂未开启').then(() => {
                        this.$router.push({path: "/"})
                    })
                    return
                }

                this.slow = false
                this.lTime = 100
                this.loopTimes = 0
                this.luckyIndex = -1
                this.currentIndex = -1

                if (parseInt(this.userInfo.integral) < parseInt(this.integral)) {
                    this.$dialog.success('积分不够').then(() => {
                        this.$router.push({path: "/"})
                    })
                    return
                }

                let that = this
                luckyIntegral().then(res => {
                    that.list.forEach(function (item, index) {
                        if (item.id == res.data.lucky_id) that.luckyIndex = index
                    });

                    that.luckyLoop()
                    that.noClick = true
                    that.getUserInfo()
                },
                err => {
                    that.$dialog.message(err.msg);
                })
            },
            loop() {
                if (this.loopTimes === 3 && !this.slow) {
                    console.log('换时间2')
                    this.slow = true
                    clearInterval(this.loopInterval)
                    this.loopInterval = setInterval(() => {
                        this.loop()
                    }, this.lTime)
                }

                if (this.start > 7) {
                    this.start = 0
                    this.loopTimes++
                }

                this.currentIndex = this.loopList[this.start]
                this.start++

                if (this.loopTimes === this.maxTimes) {
                    clearInterval(this.loopInterval)
                    this.loopTimes = 0
                    this.noClick = false
                    this.currentIndex = this.luckyIndex
                    if (this.luckyIndex > 0) {
                        this.$dialog.success('恭喜获得：' + this.list[this.luckyIndex].title)
                    } else {
                        this.luckyIndex = -1
                        this.currentIndex = -1
                        this.$dialog.error('很遗憾，您未中奖')
                    }
                }
            },
            loop2() {
                if (this.start > 7) {
                    this.start = 0
                    this.loopTimes++
                }

                this.currentIndex = this.loopList[this.start]
                this.start++

                if (this.loopTimes === this.maxTimes) {
                    this.loopTimes = 0
                    this.noClick = false
                    this.currentIndex = this.luckyIndex
                    if (this.luckyIndex > 0) {
                        this.$dialog.success('恭喜获得：' + this.list[this.luckyIndex].title)
                    } else {
                        this.luckyIndex = -1
                        this.currentIndex = -1
                        this.$dialog.error('很遗憾，您未中奖')
                    }
                } else {
                    if (this.loopTimes === 2 && !this.slow) {
                        console.log('换时间22')
                        this.slow = true
                        setTimeout(() => {
                            this.loop2()
                        }, this.lTime)
                    } else {
                        setTimeout(() => {
                            this.loop2()
                        }, this.qTime)
                    }
                }
            },
            luckyLoop() {
                if (this.noClick) {
                    this.$dialog.error('请勿重复点击')
                    return
                }

                setTimeout(() => {
                    this.loop2()
                }, this.qTime)

                // this.loopInterval = setInterval(() => {
                //     this.loop()
                // }, this.qTime)
            }
        }
    }
</script>

<style scoped>
    .bg-box{
        width: 100%;
        min-height: 100vh;
        background: url("../../assets/images/bg.png") top center no-repeat #ff8728;
        background-size: 100% auto;
        display: flex;
        align-items: center;
        padding:40px;
        flex-direction: column;
    }
    .j-list{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap:wrap;
        margin-top:14px;
        margin-bottom:14px;
    }
    .j-list span{
        display: flex;
        flex: 0 0 32%;
        background: #ffffff;
        margin-bottom: 8px;
        border-radius: 6px;
        padding: 7px;
        box-sizing: border-box;
        min-height: 90px;
    }
    .j-list span img{
        width: 100%;
        height: 100%;
    }
    .j-list span.cur{
        background: #fff228;
    }
    .head{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .head p
    {
        background: linear-gradient(to right, #d90044, #fe6920);
        border-radius: 8px;
        border: 2px solid #ffa156;
        padding: 6px 20px;
        display: flex;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        align-items: center;
        justify-content: center;
        margin-top:10px;
    }
</style>